// CTA button hover, JS handles hover since Shopify strips <style> blocks from page content
// Re-assert border-bottom:none at load time (300ms and 800ms) to override Impulse theme JS
document.addEventListener('DOMContentLoaded', function() {
  function reassertCTAStyles() {
    document.querySelectorAll('a.tlt-cta-btn').forEach(function(btn) {
      btn.style.setProperty('border-bottom', 'none', 'important');
      btn.style.setProperty('text-decoration', 'none', 'important');
    });
    var enquireBtn = document.getElementById('enquire-cta');
    if (enquireBtn) {
      enquireBtn.style.setProperty('border-bottom', '2px solid #D14727', 'important');
      enquireBtn.style.setProperty('text-decoration', 'none', 'important');
    }
  }
  reassertCTAStyles();
  setTimeout(reassertCTAStyles, 300);
  setTimeout(reassertCTAStyles, 800);

  document.querySelectorAll('a.tlt-cta-btn').forEach(function(btn) {
    btn.addEventListener('mouseenter', function() {
      this.style.setProperty('background', '#D14727', 'important');
      this.style.setProperty('color', '#ffffff', 'important');
      this.style.setProperty('text-decoration', 'none', 'important');
      this.style.setProperty('border-bottom', 'none', 'important');
    });
    btn.addEventListener('mouseleave', function() {
      this.style.setProperty('background', 'transparent', 'important');
      this.style.setProperty('color', '#D14727', 'important');
      this.style.setProperty('text-decoration', 'none', 'important');
      this.style.setProperty('border-bottom', 'none', 'important');
    });
  });

  // Custom dropdown toggle
  function toggleDropdown(dropdownId) {
      var dropdown = document.getElementById(dropdownId);
      var isOpen = dropdown.style.display === 'block';
      document.querySelectorAll('.dropdown-options').forEach(function(dd) {
          dd.style.display = 'none';
      });
      if (!isOpen) {
          dropdown.style.display = 'block';
      }
  }

  // Select a dropdown option
  function selectOption(fieldName, value, displayText) {
      document.getElementById(fieldName).value = value;
      var displayEl = document.getElementById(fieldName + '_display');
      displayEl.textContent = displayText;
      displayEl.style.color = '#333333';
      document.getElementById(fieldName + '_dropdown').style.display = 'none';
      document.getElementById(fieldName).closest('.custom-dropdown').classList.remove('error');
  }

  // Close dropdowns on outside click
  document.addEventListener('click', function(event) {
      if (!event.target.closest('.custom-dropdown')) {
          document.querySelectorAll('.dropdown-options').forEach(function(dd) {
              dd.style.display = 'none';
          });
      }
  });

  // Expose functions to global scope so inline onclick attributes in the HTML can call them
  window.toggleDropdown = toggleDropdown;
  window.selectOption = selectOption;

  // Form submission via Formspree
  var formEl = document.querySelector('.wholesale-form');
  if (!formEl) return;

  formEl.addEventListener('submit', function(event) {
      event.preventDefault();

      var form = event.target;
      var formData = new FormData(form);

      var businessType = document.getElementById('business_type').value;
      var format = document.getElementById('format').value;
      var interest = document.getElementById('interest').value;
      var businessName = document.getElementById('business_name').value;
      var contactName = document.getElementById('contact_name').value;
      var email = document.getElementById('email').value;

      if (!businessType) {
          alert('Please select your business type.');
          document.getElementById('business_type').closest('.custom-dropdown').classList.add('error');
          return;
      }

      if (!format) {
          alert('Please select loose leaf or pyramid bags.');
          document.getElementById('format').closest('.custom-dropdown').classList.add('error');
          return;
      }

      if (!interest) {
          alert('Please select what you are most interested in.');
          document.getElementById('interest').closest('.custom-dropdown').classList.add('error');
          return;
      }

      var submitBtn = form.querySelector('button[type="submit"]');
      var originalText = submitBtn.innerHTML;
      submitBtn.innerHTML = 'Sending...';
      submitBtn.disabled = true;

      var businessTypeDisplay = document.getElementById('business_type_display').textContent;
      var formatDisplay = document.getElementById('format_display').textContent;
      var interestDisplay = document.getElementById('interest_display').textContent;

      formData.append('business_type_display', businessTypeDisplay);
      formData.append('format_display', formatDisplay);
      formData.append('interest_display', interestDisplay);

      fetch('https://formspree.io/f/xyznnkqz', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
      }).then(function(response) {
          if (response.ok) {
              form.innerHTML =
                  '<div style="text-align:center; padding:40px; color:#1a1a1a;">' +
                  '<h3 style="font-size:1.3em; font-weight:600; margin-bottom:12px;">Thank you, ' + businessName + '.</h3>' +
                  '<p style="font-size:1em; line-height:1.8; color:#444444;">We\'ve received your enquiry and will be in touch within 24 hours at <strong>' + email + '</strong>.' +
                  ' We\'ll focus on <strong>' + interestDisplay + '</strong> based on your interest.</p>' +
                  '</div>';
          } else {
              response.json().then(function(data) {
                  if (data.errors) {
                      alert('There was a problem submitting the form: ' + data.errors.map(function(e) { return e.message; }).join(', '));
                  } else {
                      alert('There was a problem submitting the form. Please try again or contact us at wholesale@tleaft.co.nz');
                  }
                  submitBtn.innerHTML = originalText;
                  submitBtn.disabled = false;
              });
          }
      }).catch(function(error) {
          console.error('Form submission error:', error);
          alert('There was a problem submitting the form. Please try again or contact us at wholesale@tleaft.co.nz');
          submitBtn.innerHTML = originalText;
          submitBtn.disabled = false;
      });
  });
});
